import { CpaProductDto, CpaProductModel } from '../../data-layer/cpa/types';

export const toCpaProductsModel = (dto: CpaProductDto[]): CpaProductModel[] =>
    dto.map((item) => ({
        name: item.model_name,
        offers: item.cpa_offers.map((offer) => ({
            title: offer.title,
            url: offer.url,
            image: offer.picture.url,
            price: offer.price_info && {
                integerPart: offer.price_info.integer_part,
                currency: offer.price_info.currency,
            },
        })),
        image: item.image_urls?.[0],
        price: item.price,
    }));
